import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function MisEnvios() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [envios, setEnvios] = useState([]);
  const [recolecciones, setRecolecciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [cancelando, setCancelando] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalRecoleccion, setModalRecoleccion] = useState(null);
  const [horarioRecoleccion, setHorarioRecoleccion] = useState('matutino');
  const [solicitandoRec, setSolicitandoRec] = useState(false);

  useEffect(() => { cargarEnvios(); cargarRecolecciones(); }, []);

  const cargarEnvios = async () => {
    try {
      const response = await api.get('/envios');
      setEnvios(response.data);
    } catch (error) {
      setError('Error al cargar los envíos');
      console.error(error);
    } finally { setLoading(false); }
  };

  const cargarRecolecciones = async () => {
    try {
      const response = await api.get('/recolecciones/mias');
      setRecolecciones(response.data);
    } catch (error) {
      console.error('Error al cargar recolecciones:', error);
    }
  };

  const recoleccionPorEnvio = (envioId) => recolecciones.find(r => r.envio_id === envioId);

  const abrirModalRecoleccion = (envio) => {
    setModalRecoleccion(envio);
    setHorarioRecoleccion('matutino');
  };

  const cerrarModalRecoleccion = () => {
    setModalRecoleccion(null);
    setHorarioRecoleccion('matutino');
  };

  const handleSolicitarRecoleccion = async () => {
    if (!modalRecoleccion) return;
    setSolicitandoRec(true);
    try {
      const response = await api.post('/recolecciones', {
        envio_id: modalRecoleccion.id,
        horario_preferido: horarioRecoleccion
      });
      alert(`Recolección solicitada. Folio: ${response.data.folio}`);
      cerrarModalRecoleccion();
      cargarRecolecciones();
    } catch (error) {
      alert(error.response?.data?.error || 'Error al solicitar recolección');
    } finally {
      setSolicitandoRec(false);
    }
  };

  const handleReimprimirGuia = (urlGuia) => {
    if (urlGuia) { window.open(urlGuia, '_blank'); } else { alert('La guía no está disponible'); }
  };

  const handleCancelarEnvio = async (envioId, numeroGuia) => {
    if (!window.confirm('¿Estás seguro de cancelar este envío? El saldo será reembolsado a tu monedero.')) return;
    setCancelando(envioId);
    try {
      await api.post('/envios/cancelar', { envio_id: envioId });
      alert('Envío cancelado y saldo reembolsado exitosamente');
      cargarEnvios();
    } catch (error) {
      alert(error.response?.data?.error || 'Error al cancelar el envío');
    } finally { setCancelando(null); }
  };

  const esSinCredito = (servicio) => {
    if (!servicio) return false;
    const s = servicio.toLowerCase();
    return s.includes('sin crédito') || s.includes('sin credito');
  };

  const handleLogout = () => { logout(); navigate('/login'); };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case 'ENTREGADO': return { bg: '#d1fae5', text: '#065f46' };
      case 'EN TRÁNSITO': case 'EN TRANSITO': return { bg: '#dbeafe', text: '#1e40af' };
      case 'PENDIENTE': return { bg: '#fef3c7', text: '#92400e' };
      case 'CANCELADO': return { bg: '#fee2e2', text: '#991b1b' };
      default: return { bg: '#f3f4f6', text: '#374151' };
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      {/* Header */}
      <nav style={{ backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 0.5rem' : '0 1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', height: isMobile ? '3.5rem' : '5rem', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
              <img src="/logo.png" alt="Logo" style={{ height: isMobile ? '5rem' : '10rem' }} />
            </div>
            {isMobile ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0.5rem' }}>☰</button>
                {menuOpen && (
                  <div style={{ position: 'absolute', right: 0, top: '100%', backgroundColor: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '0.5rem', padding: '0.5rem', minWidth: '180px', zIndex: 1000 }}>
                    <button onClick={() => { navigate('/dashboard'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Dashboard</button>
                    <button onClick={() => { navigate('/crear-envio'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#ff8c00', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', fontWeight: '600' }}>+ Nuevo Envío</button>
                    <button onClick={handleLogout} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Cerrar Sesión</button>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <button onClick={() => navigate('/dashboard')} style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>Dashboard</button>
                <button onClick={() => navigate('/crear-envio')} style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', color: 'white', backgroundColor: '#ff8c00', border: 'none', borderRadius: '0.375rem', cursor: 'pointer' }}>+ Nuevo Envío</button>
                <button onClick={handleLogout} style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>Cerrar Sesión</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '1rem 0.75rem' : '2rem 1rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isMobile ? '1rem' : '2rem' }}>
          <h1 style={{ fontSize: isMobile ? '1.25rem' : '1.875rem', fontWeight: 'bold', color: '#111827' }}>Mis Envíos</h1>
          <button onClick={cargarEnvios} style={{ padding: '0.5rem 1rem', backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: '0.375rem', cursor: 'pointer', fontSize: isMobile ? '0.8rem' : '0.875rem' }}>🔄 Actualizar</button>
        </div>

        {error && (
          <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '0.75rem 1rem', borderRadius: '0.375rem', marginBottom: '1rem', fontSize: '0.875rem' }}>{error}</div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}><p style={{ color: '#6b7280' }}>Cargando envíos...</p></div>
        ) : envios.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <p style={{ color: '#6b7280', marginBottom: '1rem' }}>No tienes envíos registrados</p>
            <button onClick={() => navigate('/crear-envio')} style={{ padding: '0.75rem 1.5rem', backgroundColor: '#ff8c00', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontWeight: '600' }}>Crear mi primer envío</button>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: '1rem' }}>
            {envios.map((envio) => {
              const statusColor = getStatusColor(envio.status);
              return (
                <div key={envio.id} style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1rem' : '1.5rem', border: '1px solid #e5e7eb' }}>
                  {/* Header del envío */}
                  <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'stretch' : 'flex-start', marginBottom: '1rem', gap: isMobile ? '0.5rem' : '0' }}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem', flexWrap: 'wrap' }}>
                        <h3 style={{ fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600', color: '#111827', margin: 0 }}>
                          Guía: {envio.numero_guia}
                        </h3>
                        <span style={{ padding: '0.2rem 0.6rem', borderRadius: '9999px', fontSize: '0.7rem', fontWeight: '600', backgroundColor: statusColor.bg, color: statusColor.text }}>{envio.status}</span>
                      </div>
                      <p style={{ fontSize: '0.8rem', color: '#6b7280', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                        {envio.paqueteria} - {envio.tipo_servicio}
                        {esSinCredito(envio.tipo_servicio) && (
                          <span style={{ fontSize: '0.65rem', backgroundColor: '#fff7ed', color: '#c2410c', padding: '0.15rem 0.5rem', borderRadius: '9999px', fontWeight: '600', border: '1px solid #fed7aa' }}>Sin recolección ni cancelación</span>
                        )}
                      </p>
                      <p style={{ fontSize: '0.7rem', color: '#9ca3af', margin: '0.25rem 0 0 0' }}>
                        Creado: {new Date(envio.created_at).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </p>
                    </div>
                    <div style={{ textAlign: isMobile ? 'left' : 'right' }}>
                      <p style={{ fontSize: isMobile ? '1.125rem' : '1.25rem', fontWeight: 'bold', color: '#ff8c00', margin: 0 }}>${parseFloat(envio.costo_cliente).toFixed(2)} MXN</p>
                    </div>
                  </div>

                  {/* Detalles del envío */}
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: isMobile ? '0.75rem' : '1rem', marginBottom: '1rem' }}>
                    <div style={{ padding: isMobile ? '0.75rem' : '1rem', backgroundColor: '#f9fafb', borderRadius: '0.375rem' }}>
                      <h4 style={{ fontSize: '0.7rem', fontWeight: '600', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase' }}>📤 Remitente</h4>
                      <p style={{ fontSize: '0.8rem', color: '#111827', fontWeight: '500', margin: 0 }}>{envio.origen_nombre}</p>
                      <p style={{ fontSize: '0.7rem', color: '#6b7280', margin: '0.2rem 0 0 0', lineHeight: 1.5 }}>
                        {envio.origen_calle}<br />{envio.origen_colonia}, {envio.origen_ciudad}<br />{envio.origen_estado}, CP {envio.origen_cp}<br />Tel: {envio.origen_telefono}
                      </p>
                    </div>

                    <div style={{ padding: isMobile ? '0.75rem' : '1rem', backgroundColor: '#f9fafb', borderRadius: '0.375rem' }}>
                      <h4 style={{ fontSize: '0.7rem', fontWeight: '600', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase' }}>📥 Destinatario</h4>
                      <p style={{ fontSize: '0.8rem', color: '#111827', fontWeight: '500', margin: 0 }}>{envio.destino_nombre}</p>
                      <p style={{ fontSize: '0.7rem', color: '#6b7280', margin: '0.2rem 0 0 0', lineHeight: 1.5 }}>
                        {envio.destino_calle}<br />{envio.destino_colonia}, {envio.destino_ciudad}<br />{envio.destino_estado}, CP {envio.destino_cp}<br />Tel: {envio.destino_telefono}
                      </p>
                    </div>

                    <div style={{ padding: isMobile ? '0.75rem' : '1rem', backgroundColor: '#f9fafb', borderRadius: '0.375rem' }}>
                      <h4 style={{ fontSize: '0.7rem', fontWeight: '600', color: '#6b7280', marginBottom: '0.375rem', textTransform: 'uppercase' }}>📦 Paquete</h4>
                      <p style={{ fontSize: '0.8rem', color: '#111827', fontWeight: '500', margin: 0 }}>{envio.contenido}</p>
                      <p style={{ fontSize: '0.7rem', color: '#6b7280', margin: '0.2rem 0 0 0', lineHeight: 1.5 }}>
                        Peso: {envio.peso} kg<br />Dimensiones: {envio.largo} x {envio.ancho} x {envio.alto} cm
                      </p>
                    </div>
                  </div>

                  {/* Botones de acción */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', paddingTop: '0.75rem', borderTop: '1px solid #e5e7eb' }}>
                    <button onClick={() => handleReimprimirGuia(envio.url_guia)} style={{
                      padding: isMobile ? '0.5rem 0.75rem' : '0.5rem 1rem', backgroundColor: '#ff8c00', color: 'white',
                      border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontSize: isMobile ? '0.8rem' : '0.875rem', fontWeight: '500',
                      flex: isMobile ? '1 1 calc(50% - 0.25rem)' : 'none'
                    }}>🖨️ Imprimir Guía</button>
                    
                    {envio.status?.toUpperCase() === 'CANCELADO' ? (
                      <span style={{ padding: '0.5rem 1rem', fontSize: isMobile ? '0.8rem' : '0.875rem', color: '#9ca3af', fontWeight: '500' }}>Cancelado</span>
                    ) : envio.cancelable === 0 ? (
                      <span style={{ padding: '0.5rem 1rem', fontSize: isMobile ? '0.75rem' : '0.8rem', color: '#c2410c', fontWeight: '500' }}>No cancelable (servicio sin crédito)</span>
                    ) : envio.status?.toUpperCase() !== 'ENTREGADO' && (
                      <button onClick={() => handleCancelarEnvio(envio.id, envio.numero_guia)} disabled={cancelando === envio.id} style={{
                        padding: isMobile ? '0.5rem 0.75rem' : '0.5rem 1rem', backgroundColor: 'white', color: '#dc2626',
                        border: '1px solid #dc2626', borderRadius: '0.375rem',
                        cursor: cancelando === envio.id ? 'not-allowed' : 'pointer',
                        fontSize: isMobile ? '0.8rem' : '0.875rem', fontWeight: '500',
                        opacity: cancelando === envio.id ? 0.5 : 1,
                        flex: isMobile ? '1 1 calc(50% - 0.25rem)' : 'none'
                      }}>{cancelando === envio.id ? 'Cancelando...' : 'Cancelar envío'}</button>
                    )}

                    <button onClick={() => window.open(`https://www.google.com/search?q=rastreo+${envio.paqueteria}+${envio.numero_guia}`, '_blank')} style={{
                      padding: isMobile ? '0.5rem 0.75rem' : '0.5rem 1rem', backgroundColor: 'white', color: '#374151',
                      border: '1px solid #d1d5db', borderRadius: '0.375rem', cursor: 'pointer',
                      fontSize: isMobile ? '0.8rem' : '0.875rem', fontWeight: '500',
                      flex: isMobile ? '1 1 100%' : 'none'
                    }}>🔍 Rastrear</button>

                    {envio.status?.toUpperCase() !== 'CANCELADO' && envio.status?.toUpperCase() !== 'ENTREGADO' && !esSinCredito(envio.tipo_servicio) && (
                      (() => {
                        const rec = recoleccionPorEnvio(envio.id);
                        if (rec) {
                          const colorEstado = rec.estado === 'confirmada' ? { bg: '#d1fae5', text: '#065f46' }
                            : rec.estado === 'solicitada' ? { bg: '#dbeafe', text: '#1e40af' }
                            : { bg: '#fef3c7', text: '#92400e' };
                          return (
                            <span style={{
                              padding: '0.5rem 0.75rem', backgroundColor: colorEstado.bg, color: colorEstado.text,
                              borderRadius: '0.375rem', fontSize: isMobile ? '0.75rem' : '0.8rem', fontWeight: '600',
                              flex: isMobile ? '1 1 100%' : 'none', textAlign: 'center'
                            }}>
                              📦 Recolección {rec.estado} • {rec.folio}
                            </span>
                          );
                        }
                        return (
                          <button onClick={() => abrirModalRecoleccion(envio)} style={{
                            padding: isMobile ? '0.5rem 0.75rem' : '0.5rem 1rem', backgroundColor: 'white', color: '#1e40af',
                            border: '1px solid #1e40af', borderRadius: '0.375rem', cursor: 'pointer',
                            fontSize: isMobile ? '0.8rem' : '0.875rem', fontWeight: '500',
                            flex: isMobile ? '1 1 100%' : 'none'
                          }}>📦 Pedir Recolección</button>
                        );
                      })()
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {modalRecoleccion && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: isMobile ? '1rem' : '0' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '0.75rem', padding: isMobile ? '1.25rem' : '1.75rem', width: '100%', maxWidth: '32rem', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' }}>
            <h3 style={{ fontSize: isMobile ? '1.05rem' : '1.25rem', fontWeight: '700', color: '#111827', marginTop: 0, marginBottom: '0.5rem' }}>📦 Solicitar Recolección</h3>
            <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '1rem' }}>
              Guía {modalRecoleccion.numero_guia} • {modalRecoleccion.paqueteria}
            </p>

            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>Horario preferido</label>
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem' }}>
              {[
                { value: 'matutino', label: 'Mañana (9am - 1pm)' },
                { value: 'vespertino', label: 'Tarde (1pm - 6pm)' }
              ].map(opt => (
                <button key={opt.value} onClick={() => setHorarioRecoleccion(opt.value)} style={{
                  flex: 1, padding: '0.625rem', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600',
                  border: horarioRecoleccion === opt.value ? '2px solid #ff8c00' : '1px solid #d1d5db',
                  backgroundColor: horarioRecoleccion === opt.value ? '#fff7ed' : 'white',
                  color: horarioRecoleccion === opt.value ? '#c2410c' : '#374151'
                }}>{opt.label}</button>
              ))}
            </div>

            <div style={{ backgroundColor: '#fff7ed', border: '1px solid #fed7aa', color: '#7c2d12', padding: '0.75rem 1rem', borderRadius: '0.375rem', fontSize: '0.8rem', lineHeight: 1.5, marginBottom: '1.25rem' }}>
              Tu recolección se llevará a cabo el mismo día o día hábil siguiente en horario de 9am a 6pm. La recolección la realiza directamente <strong>{modalRecoleccion.paqueteria}</strong>. En caso de saturación de la paquetería puede no concretarse.
            </div>

            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={cerrarModalRecoleccion} disabled={solicitandoRec} style={{
                flex: 1, padding: '0.625rem', backgroundColor: 'white', color: '#374151', border: '1px solid #d1d5db',
                borderRadius: '0.375rem', cursor: solicitandoRec ? 'not-allowed' : 'pointer', fontWeight: '600'
              }}>Cancelar</button>
              <button onClick={handleSolicitarRecoleccion} disabled={solicitandoRec} style={{
                flex: 1, padding: '0.625rem', backgroundColor: solicitandoRec ? '#9ca3af' : '#ff8c00', color: 'white',
                border: 'none', borderRadius: '0.375rem', cursor: solicitandoRec ? 'not-allowed' : 'pointer', fontWeight: '600'
              }}>{solicitandoRec ? 'Solicitando...' : 'Confirmar solicitud'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MisEnvios;